module.exports = __webpack_public_path__ + "media/img/rzs_blur-71fa6010.png";